import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@alveolemtl/alveole-components/dist/style.css';
import './tailwind.css'; // Import Tailwind CSS
import './theme/globalStyle.css.js';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './components/App.js';
import { configReady } from './config/loader.js';
import CombinedProviders from './providers/CombinedProviders.js';
import { initSentry } from './utils/errorReporting.js';

if (window.self !== window.top) {
  document.documentElement.classList.add('in-iframe');
}

void configReady.then(() => {
  initSentry();

  createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <CombinedProviders><></>
        <App />
      </CombinedProviders>
    </React.StrictMode>,
  );
});
